import type { InertiaConfig } from "@inertiajs/core"
import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"

export function useAccounts() {
  const page = usePage<InertiaConfig["sharedPageProps"]>()

  const currentAccount = computed(() => page.props.auth?.account)
  const accounts = computed(() => page.props.auth?.accounts ?? [])
  const canSwitch = computed(() => accounts.value.length > 1)

  return { currentAccount, accounts, canSwitch }
}
